import { formatPercent } from '@angular/common';

const DEFAULT_PERCENT_FORMAT = '1.0-2';

export function percentFormatter(dataItemValue: number, locale: string = 'en-NZ', format: string = DEFAULT_PERCENT_FORMAT) {
  return formatPercent(dataItemValue, locale, format);
}
